const {
  location,
} = window;

export default (): string => `${location.protocol}//${location.hostname}${location.port ? `:${location.port}` : ''}`;
